import { Close } from '@mui/icons-material'
import { CircularProgress } from '@mui/material'
import { Button, Card, IconButton, Modal, Select } from 'components'
import { useGetContracts, useGetUserUnities } from 'modules/orders/hooks'
import { useState } from 'react'

type Props = {
  isOpen: boolean
  close: () => void
}

export const SelectUnityModal = ({ isOpen, close }: Props) => {
  const [unityId, setUnityId] = useState('')

  const { data: userUnities } = useGetUserUnities()

  const unitiesOptions = userUnities?.data?.map((unity: any) => ({
    id: unity.id,
    name: unity.name
  }))

  const { data: contractUrl, isFetching } = useGetContracts({
    unityId
  })

  const handleRedirect = () => {
    const redirectUrl = contractUrl
    if (contractUrl) window.open(redirectUrl, '_blank')
  }

  return (
    <Modal
      open={isOpen}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
      onClose={() => close()}
    >
      <Card
        sx={{
          width: { xs: 300, sm: 400 },
          padding: { xs: 2 }
        }}
      >
        <div
          style={{
            fontSize: '1.375rem',
            fontWeight: 600,
            marginBottom: '2rem'
          }}
        >
          Contratos
          <div
            style={{
              cursor: 'pointer',
              float: 'right',
              marginTop: '-5px'
            }}
          >
            <IconButton onClick={() => close()}>
              <Close />
            </IconButton>
          </div>
        </div>
        <Select
          label="Selecione a Unidade de Negócio"
          options={unitiesOptions || []}
          style={{ marginBottom: '1.25rem' }}
          onChange={(e: any) => setUnityId(e.target.value)}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '1rem',
            marginTop: '2rem'
          }}
        >
          <Button
            variant="contained"
            style={{ width: 100 }}
            onClick={handleRedirect}
            disabled={!unityId || isFetching || !contractUrl}
            startIcon={isFetching && <CircularProgress size={16} />}
          >
            Confirmar
          </Button>
        </div>
      </Card>
    </Modal>
  )
}
